export const roundNumber = (value: number, decimals: number) : number => {
  // eslint-disable-next-line no-restricted-properties
  const pow = Math.pow(10, decimals);
  const module = (value * pow) * (1 + Number.EPSILON);
  return Math.round(module) / pow;
};
